import React, { Component } from 'react';

class LoadingOverlay extends Component {
    render() {
        return (
            <div className="LoadingOverlay">
                <div className="sk-spinner sk-spinner-rotating-plane"/>
            </div>
        )
    }
}

export default LoadingOverlay;